// @flow
import {Axios} from "axios";
import {axiosInstance} from "../../api";

class NavigationUpdateOrderService {
	axios: Axios;

	constructor(axios: Axios) {
		this.axios = axios;
	}

	async isVinAvailable(vin: string): Promise<boolean> {
		const response = await this.axios.get("/navigation-update/order/vin", {
			params: {vin}
		});
		return response.data;
	}

	async resolvePartNumber(vin: string): Promise<?string> {
		try {
			const response = await this.axios.get("/navigation-update/order/part-number", {
				params: {vin}
			});
			return response.data;
		} catch (error) {
			if (error.response && error.response.status === 404) {
				return null;
			}
			throw error;
		}
	}

	async saveOrder(vin: string, requestCode: string, orderNumber: string): Promise<void> {
		await this.axios.post("/navigation-update/order", {
			vin,
			requestCode,
			orderNumber
		});
	}
}

const NavigationUpdateOrderServiceInstance = new NavigationUpdateOrderService(axiosInstance);
export default NavigationUpdateOrderServiceInstance;
